<template>
    <el-dropdown
        v-if="isShowLangBtn"
        class="lang-switch"
        placement="bottom"
        @command="handleCommand"
        @visible-change="onShowDropdown">
        <span :class="{'dropdown-active' : dropdownActive}">
            <i class="iconfont icon-yuyanpeizhi"></i>
            <span class="lang-text">{{ lang }}</span>
            <i class="icon el-icon-arrow-down" v-show="!dropdownActive"></i>
            <i class="icon el-icon-arrow-up" v-show="dropdownActive"></i>
        </span>
        <el-dropdown-menu slot="dropdown"
            :append-to-body="false">
            <el-dropdown-item 
                v-for="item in langOptions" 
                :key="item.languageId" 
                :class="{'custom-dropdown-item': _isActiveStyle(item.languageCode)}" 
                :command="item.languageCode">{{item.languageNativeName}}
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<style lang="scss" scoped>
.lang-switch{
    font-size: 16px;
    margin-right: 30px;
    color: #333;
    cursor: pointer;
    span{
        display: flex;
        align-items: center;
        .lang-text{
            margin-left: 10px;
        }
        i{
            margin-left: 10px;
        }
        &.dropdown-active{
            color: var(--theme);
        }
    }
}
.custom-dropdown-item{
    color: var(--theme);
    &:hover{
        color: var(--theme);
    }
}
</style>

<script>
import { Language } from '@/lib/util/language.js'
import { LanguageContent } from '@/lib/util/lang.js'
import { Header } from '@/models/header.js'
export default {
    data() {
        return {
            dropdownActive: false
        }
    },
    computed: {
        isShowLangBtn(){
            return Language.getConfig().isLanguageSwitcher === 1 ? true : false
        },
        langOptions(){
            return Language.getList()
        },
        lang(){
            const lang = this.langOptions.find(lang => lang.languageCode === this.$i18n.locale)
            if(lang){
                return lang.languageNativeName
            }
            if(this.$i18n.locale === 'zh_CN') return '简体中文'
            if(this.$i18n.locale === 'zh_TW') return '繁體中文'
            return '简体中文'
        }
    },
    methods: {
        handleCommand(command){
            if(command === LanguageContent.getPaaSJsonSuffix()){
                return
            }
            const isReload = true
            Header.switchLanguage(command, isReload)
        },
        onShowDropdown(val){
            this.dropdownActive = val
        },
        _isActiveStyle(code){
            return code === LanguageContent.getPaaSJsonSuffix()
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/layout/header/auth-menu/lang-switch.vue